<template>
	<div>
		<el-form :inline="true">
			<el-form-item label="用户昵称" label-width="80px">
				<el-input v-model="name" placeholder="用户昵称" clearable>
				</el-input>
			</el-form-item>
			<el-form-item label="手机号" label-width="80px">
				<el-input v-model="phone" placeholder="手机号" clearable>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="getStoreGoods(1)" type="success">搜索</el-button>
			</el-form-item>
		</el-form>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column label="用户头像" align="center" width="100px">
				<template slot-scope="scope"> <img width="50px" height="50px" :src="scope.row.avatarUrl" alt="" />
				</template>
			</el-table-column>
			<el-table-column label="用户昵称" align="center" prop="nickName"></el-table-column>
			<el-table-column label="用户手机号" align="center" prop="phone" width="150px"></el-table-column>
			<el-table-column label="当前角色" align="center" prop="roleId" width="140px">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.roleId == 3" type="info"> 门店 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 4" type="info"> 服务商 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 5" type="info"> 一星合伙人 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 6" type="info"> 二星合伙人 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 7" type="info"> 三星合伙人 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 8" type="info"> 四星合伙人 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 9" type="info"> 五星合伙人 </el-tag>
					<el-tag size="small" v-else-if="scope.row.roleId == 10" type="info"> 普通用户 </el-tag>
					<el-tag size="small" v-else type="info"> 其他用户 </el-tag>
				</template>
			</el-table-column>
			<el-table-column label="当前归属用户" align="center" prop="fatherName"></el-table-column>
			<el-table-column label="是否可查看商户地图" align="center" prop="mapPermissions">
				<template slot-scope="scope">
					<div v-if="scope.row.mapPermissions == 0">是</div>
					<div v-else-if="scope.row.mapPermissions == 1">否</div>
				</template>
			</el-table-column>
			<el-table-column label="是否可查看店铺统计" align="center" prop="shopStatisticsPermissions">
				<template slot-scope="scope">
					<div v-if="scope.row.shopStatisticsPermissions == 0">是</div>
					<div v-else-if="scope.row.shopStatisticsPermissions == 1">否</div>
				</template>
			</el-table-column>
			<el-table-column label="注册时间" align="center" prop="createTime"></el-table-column>
			<el-table-column label="操作" align="center" prop="icon" fixed="right" width="600px">
				<template slot-scope="{row}">
					<el-button type="info" size="mini" plain @click="setFather(row)">归属用户</el-button>
					<el-button type="warning" size="mini" plain @click="setMap(row)">地图权限</el-button>
					<el-button type="warning" size="mini" plain @click="setStatistics(row)">店铺统计权限</el-button>
					<el-button type="primary" size="mini" plain @click="allocation(row)">分配角色</el-button>
					<!-- <el-button type="primary" size="mini" plain @click="unNikname(row)">修改昵称</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total">
		</el-pagination>
		<!-- 分配角色 -->
		<el-dialog title="分配角色：" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false"
			:before-close="handleClose" top="6vh">
			<el-form :model="editForm" ref="editForm" :rules="rules2" label-width="120px" class="demo-editForm">
				<el-form-item label="分配角色：" prop="type" label-width="100px">
					<el-radio-group v-model="editForm.type">
						<el-row>
							<el-col :span="6" v-for="(i, o) in rolelist" :key="o" class="cus_col">
								<el-radio :label="i.id">{{ i.name }}</el-radio>
							</el-col>
						</el-row>
					</el-radio-group>
				</el-form-item>
				<el-form-item align="center">
					<el-button type="primary" @click="submitForm('editForm')">
						提交
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="设置商户地图权限" :visible.sync="mapVisible" width="30%" :close-on-click-modal="false"
			:before-close="handleCloseMap" top="6vh">
			<el-form :model="mapForm" ref="mapForm" label-width="120px" class="demo-editForm">
				<el-form-item label="是否可查看商户地图：" prop="mapPermissions" label-width="200px">
					<el-radio-group v-model="mapForm.mapPermissions">
						<el-radio :label="0">是</el-radio>
						<el-radio :label="1">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item align="center">
					<el-button type="primary" @click="submitForm2('mapForm')">
						提交
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="设置归属用户" :visible.sync="fatherVisible" width="30%" :close-on-click-modal="false"
			:before-close="handleCloseFather" top="6vh">
			<el-form ref="fatherForm" :model="fatherForm" :rules="rules4" label-width="150px">
				<el-form-item label="归属用户手机号码：" prop="phone">
					<el-input v-model.trim="fatherForm.phone" placeholder="填写归属用户手机号码"></el-input>
				</el-form-item>
				<el-form-item align="center">
					<el-button type="warning" @click="submitForm4">清除归属用户</el-button>
					<el-button type="primary" @click="submitForm3('fatherForm')">提交</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="设置店铺统计权限" :visible.sync="storeVisible" width="30%" :close-on-click-modal="false"
			:before-close="handleCloseStore" top="6vh">
			<el-form :model="storeForm" ref="storeForm" label-width="120px" class="demo-editForm">
				<el-form-item label="是否可查看店铺统计：" prop="shopStatisticsPermissions" label-width="200px">
					<el-radio-group v-model="storeForm.shopStatisticsPermissions">
						<el-radio :label="0">是</el-radio>
						<el-radio :label="1">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item align="center">
					<el-button type="primary" @click="submitForm5('storeForm')">
						提交
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 审核 -->
		<!-- <el-dialog title="审核" :visible.sync="examineVisible" width="60%" :close-on-click-modal="false"
			:before-close="examineClose" top="6vh">
			<el-form :model="examineform" ref="examineform" :rules="rules" label-width="120px" class="demo-editForm">
				<el-form-item label="状态：" prop="type" label-width="100px">
					<el-radio-group v-model="examineform.type">
						<el-radio :label="1">审核通过</el-radio>
						<el-radio :label="2">审核驳回</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="(examineform.type == 1 ? '通过' : '驳回') + '说明：'" label-width="100px">
					<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="examineform.content">
					</el-input>
				</el-form-item>
				<el-form-item align="center">
					<el-button type="primary" @click="examineForm('examineform')">
						保存
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog> -->
	</div>
</template>
<script>
	import VploadImg from "../inc/VploadImgTwo";
	export default {
		name: "ConfigType",
		components: {
			VploadImg
		},
		data() {
			return {
				dialogVisible: false,
				searchForm: {},
				shopForm: {},
				// 审核
				// examineform: {
				// 	type:0,
				// 	content:''
				// },
				delBtlStatu: true,
				examineVisible: false,
				tableData: [],
				multipleSelection: [],
				filesd: [],
				// 分配角色
				editForm: {
					type: 0
				},
				mapForm: {
					mapPermissions: null,
					userId: null,
				},
				storeForm: {
					shopStatisticsPermissions: null,
					userId: null,
				},
				fatherForm: {
					phone: '',
					userId: ''
				},
				mapVisible: false,
				fatherVisible: false,
				storeVisible: false,
				total: 0,
				size: 10,
				current: 1,
				selectId: '',
				name: '',
				phone: '',
				rolelist: [],
				// 验证规则
				// rules:{
				// 	type:[
				// 		{ required: true, message: '请选择审核状态', trigger: 'change' }
				// 	]
				// },
				rules2: {
					type: [{
						required: true,
						message: '请选择角色',
						trigger: 'change'
					}]
				},
				rules4: {
					phone: [{
						required: true,
						message: '请填写归属用户手机号码',
						trigger: 'change'
					}]
				},
			}
		},
		created() {
			//const query = this.$route.query;
			//console.log(query);
			this.getConfigType();
			this.getrole()
		},
		methods: {

			getrole() {
				this.$axios.get("/admin/role/list", {
					pageNo: 1,
					pageSize: 999
				}).then(res => {
					console.log(res.data.records);
					this.rolelist = res.data.records.filter((item) => {
						return item.id != 1 && item.id != 10
					})
				})
			},
			unNikname(obj) {
			
				this.$prompt('请输入要修改的昵称', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showInput: true
				}).then(({
					value
				}) => {
				if(value){
					this.$axios
						.post('/admin/userBase/updateUserNickName', {
							nickName:value,
							userId: obj.userId
						}, ).then((res) => {
							// this.getCommunity()
							this.$message({
								showClose: true,
								message: '恭喜你，操作成功',
								type: 'success',
								onClose: () => {
									this.$emit('refreshDataList')
								},
							})
							this.getConfigType()
							this.dialogVisible = false
						})
				}else{
					this.$message({
						type:'info',
						message:'请输入要修改昵称'
					});
				}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			// 设置地图权限(打开对话框)
			setMap(row) {
				this.mapForm = {
					userId: row.userId,
					mapPermissions: row.mapPermissions
				}
				this.mapVisible = true
			},
			setFather(row) {
				this.fatherForm.userId = row.userId
				this.fatherVisible = true
			},
			setStatistics(row) {
				this.storeForm = {
					userId: row.userId,
					shopStatisticsPermissions: row.shopStatisticsPermissions
				}
				this.storeVisible = true
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.editForm))
						this.$axios
							.post('/admin/role/updateUserRole', {
								userId: obj.userId,
								roleId: obj.type
							}, ).then((res) => {
								// this.getCommunity()
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose: () => {
										this.$emit('refreshDataList')
									},
								})
								this.getConfigType()
								this.dialogVisible = false
							})
					} else {
						return false
					}
				})
			},
			submitForm2(formName) {
				console.log(this.mapForm);
				this.$axios
					.post('/admin/userBase/updateUserMapPermissions', this.mapForm).then((res) => {
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
						})
						this.getConfigType()
						this.handleCloseMap()
					})
			},
			submitForm3(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios
							.post('/admin/userBase/updateUserFatherId', this.fatherForm).then((res) => {
								if (res.code == 0) {
									this.$message({
										showClose: true,
										message: '恭喜你，操作成功',
										type: 'success',
									})
									this.getConfigType()
									this.handleCloseFather()
								}
							})
					}
				})
			},
			submitForm4() {
				this.$confirm('确认清除当前用户的归属用户?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('/admin/userBase/cancelUserFatherId', {
						id: this.fatherForm.userId
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							})
							this.getConfigType()
							this.handleCloseFather()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			submitForm5(formName) {
				this.$axios
					.post('/admin/userBase/updateUserShopStatisticsPermissions', this.storeForm).then((res) => {
						if (res.code == 0) {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							})
							this.getConfigType()
							this.handleCloseStore()
						}
					})
			},
			examineClose() {
				this.examineVisible = false
			},
			handleClose() {
				this.dialogVisible = false
			},
			handleCloseMap() {
				this.mapVisible = false
				this.mapForm = {
					mapPermissions: null,
					userId: null,
				}
			},
			handleCloseFather() {
				this.fatherVisible = false
				this.$refs.fatherForm.resetFields();
				this.fatherForm = {
					phone: '',
					userId: ''
				}
			},
			handleCloseStore() {
				this.storeVisible = false
				this.storeForm = {
					userId: null,
					shopStatisticsPermissions: null
				}
			},
			allocation(row) {
				var obj = JSON.parse(JSON.stringify(row))
				console.log(obj);
				this.editForm = {
					userId: obj.userId,
					type: obj.roleId
				}
				this.dialogVisible = true
			},
			getStoreGoods(e) {
				this.current = 1
				this.getConfigType();
			},
			delHandle(id) {
				this.$axios.post("/admin/brand/delete", {
					id: id
				}).then(res => {
					this.getConfigType()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {

						}
					});
				})
			},
			setsu() {
				this.id = ''
				this.imgUrl = ''
				this.name = ''
				this.sort = 0
				this.storeGoodsId = ''
				this.filesd = []
				this.dialogVisible = true
			},
			getImg(url, add) {
				if (add == 1) {
					this.imgUrl = url
				} else if (add == 0) {
					this.imgUrl = ''
				}
			},
			handleClose() {
				this.dialogVisible = false
			},
			// submitForm() {
			// 	if (this.id) {
			// 		this.$axios.post("/admin/homeCarouse/updateHomeCarouse", {
			// 			id: this.id,
			// 			imgUrl: this.imgUrl,
			// 			name: this.name,
			// 			sort: this.sort,
			// 			state: 1,
			// 		}).then(res => {
			// 			this.dialogVisible = false
			// 			this.getConfigType()
			// 			this.$message({
			// 				showClose: true,
			// 				message: '恭喜你，操作成功',
			// 				type: 'success',
			// 				onClose: () => {
			// 				},
			// 			})
			// 		})
			// 	} else {
			// 		this.$axios.post("/admin/brand/add", {
			// 			cover: this.imgUrl,
			// 			name: this.name,
			// 			sort: this.sort,
			// 		}).then(res => {
			// 			this.dialogVisible = false
			// 			this.getConfigType()
			// 			this.$message({
			// 				showClose: true,
			// 				message: '恭喜你，操作成功',
			// 				type: 'success',
			// 				onClose: () => {

			// 				},
			// 			})
			// 		})
			// 	}
			// },
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.delBtlStatu = val.length == 0
			},
			handleSizeChange(val) {
				this.size = val
				this.getConfigType()
			},
			handleCurrentChange(val) {
				this.current = val
				this.getConfigType()
			},
			crileCurrentChange() {
				this.currents = val
				this.getInformations()
			},
			crileChange(val) {
				this.currents = val
				this.getInformations()
			},
			//获取常量数据配置列表
			getConfigType() {
				this.$axios.post("/admin/userBase/getUserList", {
					pageNo: this.current,
					pageSize: this.size,
					phone: this.phone,
					name: this.name,
					userType: '1'
				}).then(res => {
					console.log(res);
					this.tableData = res.data.records
					this.size = res.data.size
					this.current = res.data.current
					this.total = res.data.total
				})
			},
			UpdateConfigTypeButton(id) {
				this.id = id.id
				this.imgUrl = id.imgUrl
				this.name = id.name
				this.filesd = []
				var fles = {
					url: id.imgUrl
				}
				this.filesd.push(fles)
				this.dialogVisible = true
			}
		}
	}
</script>

<style scoped>
	.cus_col {
		margin-bottom: 20px;
	}

	.el-button {
		padding: 0 10px;
		height: 35px;
		line-height: 35px;
		font-size: 15px;
		margin-right: 10px;
	}
</style>